import React, { useEffect, useState } from 'react';
import { getMyStartupEvents } from '../../api';

const EVENT_TYPE_STYLES = {
  dossier_action: { color: '#2196F3', bg: '#E3F2FD', icon: '📋' },
  scoring: { color: '#FF9800', bg: '#FFF3E0', icon: '📊' },
  validation: { color: '#4CAF50', bg: '#E8F5E9', icon: '✅' },
  rejection: { color: '#F44336', bg: '#FFEBEE', icon: '❌' },
  document: { color: '#9C27B0', bg: '#F3E5F5', icon: '📄' },
  score_published: { color: '#1565C0', bg: '#E3F2FD', icon: '🏆' },
  score_unpublished: { color: '#607D8B', bg: '#ECEFF1', icon: '🔒' },
};

function getEventStyle(type) {
  return EVENT_TYPE_STYLES[type] || { color: '#607D8B', bg: '#ECEFF1', icon: '📌' };
}

export default function StartupEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyStartupEvents()
      .then(setEvents)
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading">Chargement des événements...</div>;

  return (
    <div style={{ padding: '32px 0' }}>
      <div className="container">
        <h1 style={{ marginBottom: 8, fontSize: 22 }}>Gestionnaire d'événements</h1>
        <p style={{ color: 'var(--text-light)', marginBottom: 24, fontSize: 14 }}>
          Suivez en temps réel les actions effectuées sur votre dossier de candidature.
        </p>

        {events.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: 48 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📭</div>
            <h3 style={{ color: 'var(--text-light)', fontWeight: 500 }}>Aucun événement</h3>
            <p style={{ color: 'var(--text-light)', fontSize: 13, marginTop: 8 }}>
              Les actions effectuées par les analystes sur votre dossier apparaîtront ici.
            </p>
          </div>
        ) : (
          <div style={{ position: 'relative' }}>
            {/* Timeline line */}
            <div style={{
              position: 'absolute', left: 28, top: 0, bottom: 0, width: 2,
              background: 'linear-gradient(to bottom, var(--primary), var(--border))',
              zIndex: 0
            }} />

            {events.map((ev, idx) => {
              const style = getEventStyle(ev.event_type);
              const date = new Date(ev.created_at);
              return (
                <div key={ev.id || idx} style={{
                  display: 'flex', gap: 16, marginBottom: 16, position: 'relative', zIndex: 1
                }}>
                  {/* Timeline dot */}
                  <div style={{
                    width: 56, flexShrink: 0, display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
                    paddingTop: 14
                  }}>
                    <div style={{
                      width: 36, height: 36, borderRadius: '50%', background: style.bg,
                      border: `2px solid ${style.color}`, display: 'flex', alignItems: 'center',
                      justifyContent: 'center', fontSize: 18
                    }}>
                      {style.icon}
                    </div>
                  </div>

                  {/* Event card */}
                  <div className="card" style={{
                    flex: 1, padding: '14px 18px', borderLeft: `3px solid ${style.color}`,
                    transition: 'box-shadow 0.2s ease'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 6 }}>
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                        <span className="badge" style={{ background: style.bg, color: style.color, fontSize: 10, fontWeight: 600 }}>
                          {ev.event_label || ev.event_type}
                        </span>
                      </div>
                      <span style={{ fontSize: 11, color: 'var(--text-light)', whiteSpace: 'nowrap' }}>
                        {date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
                        {' à '}
                        {date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>

                    {ev.event_description && (
                      <div style={{ fontSize: 13, color: '#444', lineHeight: 1.5 }}>
                        {ev.event_description}
                      </div>
                    )}

                    {ev.action_by_email && (
                      <div style={{ fontSize: 11, color: 'var(--text-light)', marginTop: 6 }}>
                        Par : {ev.action_by_email}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
